import { IconButton } from "domains/ui/components/Button";
import Icon from "domains/ui/components/Icon";

import {
  HStack,
  Menu,
  MenuButton,
  // eslint-disable-next-line no-restricted-imports
  MenuItem,
  MenuList,
  Spinner,
  Text,
  Tooltip,
} from "@chakra-ui/react";

interface MoreTooltipProps {
  options: {
    id: string;
    label: React.ReactNode;
    value: any;
    isLoading?: boolean;
    onClick?: () => void;
  }[];
  onOpen?: () => void;
  onClose?: () => void;
}

export default function MoreTooltip({
  options,
  onOpen,
  onClose,
}: MoreTooltipProps) {
  if (!options.length) return null;

  return (
    <Menu closeOnSelect={false} isLazy onClose={onClose} onOpen={onOpen}>
      <MenuButton
        as={IconButton}
        aria-label="Parameters"
        icon={<Icon id="Ui/Sandwich" h="8px" />}
        size="sm"
        tooltip="Parameters"
        variant="secondaryV2"
      />

      <MenuList zIndex="popover" py={2} bgColor="backgroundSecondary.500">
        {options.map((option) => (
          <TooltipItem
            key={option.id}
            title={option.label}
            value={option.value}
            isLoading={option.isLoading}
            onClick={option.onClick}
          />
        ))}
      </MenuList>
    </Menu>
  );
}

// ------------------------------------

interface TooltipItemProps {
  title: React.ReactNode;
  value: React.ReactNode;
  isLoading?: boolean;
  onClick?: () => void;
}

function TooltipItem({
  title,
  value,
  onClick,
  isLoading = false,
}: TooltipItemProps) {
  const tooltip =
    typeof value === "string" && value.length >= 25 ? value : undefined;

  return (
    <Tooltip label={tooltip}>
      <MenuItem
        w="260px"
        px={2}
        py={1}
        borderRadius="md"
        _hover={onClick ? { bgColor: "background.500" } : {}}
        pointerEvents={!onClick ? "none" : undefined}
        bgColor="backgroundSecondary.500"
        closeOnSelect={false}
        onClick={onClick}
      >
        <HStack w="full">
          <Text
            flex={1}
            color="textSecondary"
            whiteSpace="nowrap"
            size="body.bold.md"
          >
            {title}
          </Text>

          {isLoading ? (
            <Spinner color="textTertiary" size="xs" />
          ) : (
            <Text color="textPrimary" isTruncated size="body.bold.md">
              {value}
            </Text>
          )}
        </HStack>
      </MenuItem>
    </Tooltip>
  );
}
